var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","fluid":"","fill-height":""}},[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-card',[_c('moderator-accountance-time',{key:_vm.$route.fullPath})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }